import { render, staticRenderFns } from "./InstitutionListView.vue?vue&type=template&id=4b66cdd1&"
import script from "./InstitutionListView.vue?vue&type=script&lang=js&"
export * from "./InstitutionListView.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionListView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports